module.exports = __webpack_public_path__ + "img/广西电力职业技术学院.8249ebd4.png";